import type { Connection } from "~/models/Connection";
import { ApiBaseService, type ApiServiceConfig } from "./ApiBaseService";
import type { ApiResponse } from "~/types/ApiResponse";

interface AutoCompleteOptions {
    includedPrimaryTypes?: string[];
    languageCode?: string;
    includedRegionCodes?: string[];
    locationBias?: Record<string, any>;
    ipbias?: string;
    inputOffset?: number;
    regionCode?: string;
    sessionToken?: string;
}

export default class DataLookupService extends ApiBaseService {
    private automation_id: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config)

        this.automation_id = uuid;
    }

    public async getObjects(connection_id: string): Promise<ApiResponse<any>> {
        return this.request(this.route("api.automations.data-lookup.objects", "automations/{automation_id}/data-lookup/{connection_id}/objects", {
            automation_id: this.automation_id,
            connection_id,
        }), {
            method: "GET",
        });
    }
}

